import { ThiSinhService } from "../services/thisinh.service";
import {stringB64toFile} from "../helpers/fileConvert"

var thisinh = {
	hoTen: "",
	ngaySinh: (new Date().getFullYear() - 18) + "-07-22",
	soCmnd: "",
	soDienThoai: null,
	email: "",
	maDoiTuong: null,
	maKhuVuc: null,
	hoKhau: "",
	diaChi: "",
	hoTenBo: "",
	sdtbo: 0,
	hoTenMe: "",
	sdtme: 0,
	lop10TruongId: "",
	lop11TruongId: "",
	lop12TruongId: "",
	gioiTinh: null,
	sbd: "",
	ngayCap: (new Date().getFullYear()) + `-${new Date().getMonth()}-${new Date().getDate()}`,
	fileCmndTypeFile: [],
	fileDinhKemCmnd: [],
	fileBaiBaoTypeFile: [],
	fileDeTaiTypeFile: [],
	fileMinhChungTypeFile: [],
};

var state = {
	thisinh: { ...thisinh },
	existCmnd: false,
	existSbd: false,
	httpFileDangKy: ""
};

var getters = {};

var mutations = {
	updateTruongId(state, { truongId, lop }) {
		switch (lop) {
			case 10:
				state.thisinh.lop10TruongId = truongId;
				break;
			case 11:
				state.thisinh.lop11TruongId = truongId;
				break;
			case 12:
				state.thisinh.lop12TruongId = truongId;
				break;
		}
	},

	saveThiSinh(state, data) {
		state.thisinh = {
			...data,
			fileCmndTypeFile: [],
			fileBaiBaoTypeFile: [],
			fileDeTaiTypeFile: [],
			fileMinhChungTypeFile: [],
		};
	},
	updateSoCmnd(state, soCmnd) {
		state.thisinh.soCmnd = soCmnd;
	},

	loadNew(state) {
		state.thisinh = { ...thisinh };
	},

	checkExistCmnd(state, data) {
		state.existCmnd = data;
	},
	checkExistSbd(state, data) {
		state.existSbd = data;
	},

	saveHttpFileDangKy(state, data) {
		state.httpFileDangKy = data;
	},

	updateFileCmnd(state, data) {
    const fileDinhKemCmnd = data ?? [];
    const thisinh = state.thisinh;
    state.thisinh = { ...thisinh, fileDinhKemCmnd: [...fileDinhKemCmnd] };
  },

	updateFileDinhKemCmnd(state, data) {
		state.thisinh.fileDinhKemCmnd = [...data];
	}
};

var actions = {
	async dangKyThiSinh({ rootState, commit, dispatch }, { thisinh, file }) {
		if (rootState.tohop.diems.length > 0) {
			await dispatch(
				"nguyenvong/updateDiemXetTuyen",
				{
					diems: rootState.tohop.diems,
					mons: rootState.tohop.mons,
				},
				{ root: true },
			);
		}


		thisinh.ngaySinh = formatDate(thisinh.ngaySinh);
		let dotdangkythisinh = {
			dotDangKyId: rootState.dotdangky.dotdangky.dotDangKyId,
			regCode: "",
			changeCount: 0,
			status: "moitao",
		};

		return ThiSinhService.postThiSinh({
			thiSinh: thisinh,
			nguyenVongs: rootState.nguyenvong.nguyenvongs,
			dotDangKyThiSinh: dotdangkythisinh,
			file: file,
			diems: rootState.tohop.diems
		})
			.then(async (response) => {
				if (response.status === 200 || response.status === 201) {
					await commit("saveThiSinh", response.data.thiSinh);
					commit("saveHttpFileDangKy", response.data.httpFileDangKy);
					commit("dotdangkythisinh/saveDotDangKy", response.data.dotDangKyThiSinh, { root: true },)
				}
				return response;
			})
			.catch((error) => {
				return error.message;
			});
	},

	async dangKyThiSinhCaoHoc({ rootState, commit }, { thisinh, nguyenvong }) {
		thisinh.ngaySinh = formatDate(thisinh.ngaySinh);
		let dotdangkythisinh = {
			dotDangKyId: rootState.dotdangky.dotdangky.dotDangKyId,
			regCode: "",
			changeCount: 0,
			status: "moitao",
		};
		const fileCmnd = thisinh.fileDinhKemCmnd ?? [];
		const fileBaiBao = thisinh.fileBaiBaoTypeFile ?? [];
		const fileDeTai = thisinh.fileDeTaiTypeFile ?? [];
		const fileMinhChung = thisinh.fileMinhChungTypeFile ?? [];
		const chungChiNgoaiNgu = nguyenvong.chungChiNgoaiNgu ?? [];

		return ThiSinhService.postThiSinhCaoHoc({
			thiSinh: { ...thisinh, fileBaiBao: null, fileDeTai: null, fileCmnd: null },
			nguyenVongs: [{ ...nguyenvong, chungChiNgoaiNgu: null }],
			dotDangKyThiSinh: dotdangkythisinh,
			fileCmnd: fileCmnd,
			fileBaiBao: fileBaiBao,
			fileDeTai: fileDeTai,
			chungChiNgoaiNgu: chungChiNgoaiNgu,
			fileMinhChung: fileMinhChung,
		})
			.then(async (response) => {
				if (response.status === 200 || response.status === 201) {
					await commit("saveThiSinh", response.data.thiSinh);
					commit("saveHttpFileDangKy", response.data.httpFileDangKy);
					commit("dotdangkythisinh/saveDotDangKy", response.data.dotDangKyThiSinh, { root: true },)
					commit("nguyenvong/saveNguyenVong", [{ ...nguyenvong }], { root: true },)
				}
				return response;
			})
			.catch((error) => {
				return error.message;
			});
	},
	async updateThiSinhCaoHoc({ rootState, commit }, { thisinh, nguyenvong, }) {
		thisinh.ngaySinh = formatDate(thisinh.ngaySinh);
		let dotdangkythisinh = {
			dotDangKyId: rootState.dotdangky.dotdangky.dotDangKyId,
			regCode: "",
			changeCount: 0,
			status: "moitao",
		};
		const fileCmnd = thisinh.fileDinhKemCmnd ?? [];
		const fileBaiBao = thisinh.fileBaiBaoTypeFile ?? [];
		const fileDeTai = thisinh.fileDeTaiTypeFile ?? [];
		const fileMinhChung = thisinh.fileMinhChungTypeFile ?? [];
		const chungChiNgoaiNgu = nguyenvong.chungChiNgoaiNgu ?? [];


		return ThiSinhService.updateThiSinhCaoHoc({
			thiSinh: { ...thisinh, fileBaiBao: null, fileDeTai: null, fileCmnd: null },
			nguyenVongs: [{ ...nguyenvong, chungChiNgoaiNgu: null }],
			dotDangKyThiSinh: dotdangkythisinh,
			fileCmnd: fileCmnd,
			fileBaiBao: fileBaiBao,
			fileDeTai: fileDeTai,
			chungChiNgoaiNgu: chungChiNgoaiNgu,
			fileMinhChung: fileMinhChung,
      dotDangKyId: rootState.dotdangky.dotdangky.dotDangKyId
		})
			.then(async (response) => {
				if (response.status === 200 || response.status === 201) {
					await commit("saveThiSinh", response.data.thiSinh);
					commit("saveHttpFileDangKy", response.data.httpFileDangKy);
					commit("dotdangkythisinh/saveDotDangKy", response.data.dotDangKyThiSinh, { root: true },)
					commit("nguyenvong/saveNguyenVong", [{ ...nguyenvong }], { root: true },)
				}
				return response;
			})
			.catch((error) => {
				return error.message;
			});
	},

	findThiSinhDKHocBa({ commit, dispatch }, payload) {
		return ThiSinhService.findThiSinhDKHocBa(payload)
			.then(async (response) => {
				if (response.status === 200) {
					await commit("saveThiSinh", response.data);
					// await dispatch("dotdangky/getDotDangKyHocBaHT", null, { root: true });
					await dispatch(
						"nguyenvong/getNguyenVongsByThiSinhId",
						{ thiSinhId: response.data.thiSinhId },
						{ root: true },
					);
					await [10, 11, 12].forEach((item) => {
						dispatch(
							"truong/getTinhsTruongId",
							{ truongId: response.data[`lop${item}TruongId`], lop: item },
							{ root: true },
						);
					});
				}
				return response;
			})
			.catch((error) => error.message);
	},

	findThongTinChinhSua({ commit, dispatch }, payload) {
		return ThiSinhService.findThongTinChinhSua(payload)
			.then(async (response) => {
				if (response.status === 200) {
					const fileDinhKemCmndOld = response.data.fileDinhKemCmndOld;
					const fileDinhKemCmnd = [];
					await commit("saveThiSinh", response.data.thiSinh);
					fileDinhKemCmndOld?.forEach((item, index) => {
						fileDinhKemCmnd.push(stringB64toFile(item, `file_cmnd_${index}`))
					})
					commit("updateFileDinhKemCmnd", fileDinhKemCmnd);
					await commit(
						"dotdangky/getDotDangKy",
						response.data.dotDangKy,
						{ root: true },
					);
					// if (response.data.ksNguyenVongs.length > 0)
					// await commit("khaosat/getKhaoSats", response.data.ksNguyenVongs, { root: true },)
					await commit("dotdangkythisinh/saveDotDangKy", response.data.dotDangKyThiSinh, { root: true },)
          if(response.data.dotDangKy.loaiDot != 'CAOHOC') {
            await dispatch(
              "nguyenvong/getNguyenVongsByThiSinhId",
              response.data.thiSinh.nguyenVong,
              { root: true },
            );
            await [10, 11, 12].forEach((item) => {
              dispatch(
                "truong/getTinhsTruongId",
                { truongId: response.data.thiSinh[`lop${item}TruongId`], lop: item },
                { root: true },
              );
            });
          } else {
            commit(
              "nguyenvong/saveNguyenVongCaoHoc",
              response.data.thiSinh.nguyenVong,
              { root: true },
						);
						const fileDinhKemCcnnOld = response.data.fileDinhKemCcnnOld;
						const fileDinhKemCcnn = [];
						fileDinhKemCcnnOld?.forEach((item, index) => {
							fileDinhKemCcnn.push(stringB64toFile(item, `chung_chi_nn_${index}`))
						})
            commit(
              "nguyenvong/updateFileDinhKemCcnn",
              fileDinhKemCcnn,
              { root: true },
            );
          }
					
				}
				return response;
			})
			.catch((error) => { return error.message });
	},

	findThiSinhDKTHPT({ commit, dispatch }, payload) {
		return ThiSinhService.findThiSinhDKTHPT(payload)
			.then(async (response) => {
				if (response.status === 200) {
					await commit("saveThiSinh", response.data);
					// await dispatch("dotdangky/getDotDangKyHocBaHT", null, { root: true });
					await dispatch(
						"nguyenvong/getNguyenVongsByThiSinhId",
						{ thiSinhId: response.data.thiSinhId },
						{ root: true },
					);
					await [10, 11, 12].forEach((item) => {
						dispatch(
							"truong/getTinhsTruongId",
							{ truongId: response.data[`lop${item}TruongId`], lop: item },
							{ root: true },
						);
					});
				}
				return response;
			})
			.catch((error) => error.message);
	},

	findThiSinhByCMND({ commit }, soCmnd) {
		return ThiSinhService.findThiSinhByCMND(soCmnd)
			.then((response) => {
				if (response.status === 200) commit("saveThiSinh", response.data);
				return response;
			})
			.catch((error) => error.message);
	},

	// updateThiSinh({ commit }, payload) {
	// 	return ThiSinhService.updateThiSinh(payload)
	// 		.then((response) => {
	// 			if (response.status === 204) commit("saveThiSinh", payload);
	// 			return response;
	// 		})
	// 		.catch((error) => error.message);
	// },
	async updateThiSinh(
		{ rootState, commit, dispatch },
		{ thisinh, file },
	) {
		if (rootState.tohop.diems.length > 0) {
			await dispatch(
				"nguyenvong/updateDiemXetTuyen",
				{
					diems: rootState.tohop.diems,
					mons: rootState.tohop.mons
				},
				{ root: true },
			);
		}

		thisinh.ngaySinh = formatDate(thisinh.ngaySinh);

		return ThiSinhService.updateThiSinh({
			thiSinh: thisinh,
			nguyenVongs: rootState.nguyenvong.nguyenvongs,
			file: file,
			ksNguyenVongs: rootState.khaosat.khaosats,
			diems: rootState.tohop.diems,
			dotDangKyId: rootState.dotdangky.dotdangky.dotDangKyId
		})
			.then(async (response) => {
				if (response.status === 204 || response.status === 200) {
					commit("saveThiSinh", thisinh);
					commit("saveHttpFileDangKy", response.data.httpFileDangKy);
					commit("dotdangkythisinh/saveDotDangKy", response.data.dotDangKyThiSinh, { root: true },)
				}
				return response;
			})
			.catch((error) => {
				return error.message;
			});
	},

	checkExistCmnd({ commit }, soCmnd) {
		return ThiSinhService.checkExistCmnd(soCmnd)
			.then((response) => {
				if (response.status === 200) commit("checkExistCmnd", response.data);
				return response;
			})
			.catch((error) => error.message);
	},
	checkExistSbd({ commit }, soCmnd) {
		return ThiSinhService.checkExistSbd(soCmnd)
			.then((response) => {
				if (response.status === 200) commit("checkExistSbd", response.data);
				return response;
			})
			.catch((error) => error.message);
	},

	// eslint-disable-next-line no-unused-vars
	downloadFileDangKy({ commit }, regCode) {
		return ThiSinhService.downloadFileDangKy(regCode).then(response => response).catch(error => error.response);
	},
	// eslint-disable-next-line no-unused-vars
	downloadFileHoSo({ commit }, thiSinhId) {
		return ThiSinhService.downloadFileHoSo(thiSinhId).then(response => response).catch(error => error.response);
	},
};

let formatDate = (date) => {
	let d = new Date(date),
		month = "" + (d.getMonth() + 1),
		day = "" + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;

	return [year, month, day].join("-");
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
